import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { AppStore } from '@app/core/store/app.store';
import { DialogService } from '@siu/shared';

@Component({
  selector: 'app-mensaje-disponibilidad',
  templateUrl: './mensaje-disponibilidad.component.html',
  styleUrls: ['./mensaje-disponibilidad.component.css']
})
export class MensajeDisponibilidadComponent implements OnInit {

  ocultarSubmit: boolean = false;
  tituloModal: string = "MENSAJE PROCEDIMIENTO TUPA";
  showGuia: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<MensajeDisponibilidadComponent>,
    public dialog: DialogService,
    private appStore: AppStore

  ) { }

  ngOnInit(): void {
  }



  handleClose = () => {

    this.dialogRef.close();

  };

  ngOnDestroy() {
  }

}
